import { render } from "./componentList.vue?vue&type=template&id=ba18bf42"
import script from "./componentList.vue?vue&type=script&lang=js"
export * from "./componentList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__